import HomeProvider from "contexts/homeContext";
import { useController } from "./Controller";
import { homeTabs } from "helpers/constants";
import { Following } from "../components/Following";
import { Trending } from "../components/Trending";
import { Upcoming } from "../components/Upcoming";
import { New } from "../components/New";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export default function Home() {
  const { currentTab, setCurrentTab } = useController();

  const tabRender = () => {
    switch (currentTab) {
      case "Following":
        return <Following />;

      case "Trending":
        return <Trending />;

      case "Upcoming":
        return <Upcoming />;

      case "New":
        return <New />;

      default:
        break;
    }
  };

  return (
    <HomeProvider>
      <div className="w-full flex justify-start items-center gap-6 border-b border-gray-800 text-left fixed left-0 right-0 top-12 bg-base-300 px-4 z-10">
        {homeTabs.map((tab) => (
          <div
            key={tab.name}
            className={classNames(
              tab.name === currentTab
                ? "border-secondary text-white"
                : "border-transparent text-slate-300 hover:border-secondary hover:text-white",
              "whitespace-nowrap border-b-4 rounded text-sm font-normal py-3 w-24 px-2 cursor-pointer"
            )}
            onClick={() => {
              setCurrentTab(tab.name);
            }}
          >
            {tab.name}
          </div>
        ))}
      </div>

      {tabRender()}
    </HomeProvider>
  );
}
